import imageDefault from '@/main/assets/images/product/xnuup-main-symbol-black.png';
import imageDefaultErrorBoundary from '@/main/assets/images/common/ErrorBoundaryXnuup.png';

export const IMAGE_DEFAULT = imageDefault;
export const IMAGE_DEFAULT_ERROR_BOUNDARY = imageDefaultErrorBoundary;

// Layout
export const LAYOUT_HEIGHT_HEADER = 70; // px
export const Z_INDEX_MODAL = 999;
